import { TaskListAreasPage } from "./TaskListAreasPage";

export default TaskListAreasPage;
